export { Bottom } from './Bottom';
export { Payments } from './Payments';
export { Form } from './Form';
export { Amount } from './Amount';
export { Bonuses } from './Bonuses';
export { InfoFaq } from './InfoFaq';
